module.exports = __webpack_public_path__ + "static/img/notice_pop_bg.1cb5f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/notice_pop_bg.png
// module id = o4gY
// module chunks = 2